export const DESTINATION_TYPE = {
  TABLE: "table",
  ROOM: "room",
};

export const ORDER_SOURCE = {
  TABLE: "dineIn",
  ROOM: "room",
};
